import { createFileRoute } from '@tanstack/react-router';
import { Page } from '@trukt/ui/Page';
import ReportListView from '../admin/orders/report-view';
const Component = () => <Page route={{ Component: ReportListView, title: 'Report Details' }} />;
export const Route = createFileRoute('/admin/order/reports/$reportId')({ component: Component });
